// Imports
import { Dispatch } from 'redux';
import axios from 'axios';
import {liveBaseURL} from "../../api/api";
import {
  setProceedToPay,
  setloading,
  seterror,
  resetProceedToPay,
} from '../reducers/coursePaymentReducer';

// Action Creator: proceedToPayData
const proceedToPayData = (token: string, assignment: any, isAssignment: boolean , price: number, purchaseType: string = "course", bookingData: any = null) => async (dispatch: Dispatch) => {
  dispatch(setloading(true));


  

  // For meet_session, call the bookings endpoint directly (skip create-order)
  if (purchaseType === "meet_session" && bookingData) {
    const bookingPayload = {
      teacher_id: bookingData.teacherId,
      course_id: bookingData.course ? bookingData.course : null,
      offering_id: bookingData.offeringId,
      start: bookingData.start,
    };

    const config = {
      method: 'post',
      url: `${liveBaseURL}/students/meet/bookings/`,
      headers: {
        Authorization: `Token ${token}`,
        'Content-Type': 'application/json',
      },
      data: bookingPayload,
    };

    try {
      const response = await axios.request(config);

      if (response.data?.status === 200 || response.status === 201) {
        // Extract order_id from payment object in booking response
        const orderIdFromBooking = response.data?.data?.payment?.order_id;

        if (orderIdFromBooking) {
          // Set the order_id in state so payment flow can use it
          const payloadData: any = {
            order_id: orderIdFromBooking,
            purchase_type: "meet_session",
            booking_id: response.data?.data?.booking?.id,
            booking_data: response.data?.data,
          };
          dispatch(setProceedToPay(payloadData));
          dispatch(setloading(false));
          return { ok: true, data: response.data?.data };
        } else {
          dispatch(setloading(false));
          console.warn("No order_id found. Response data:", response.data);
          dispatch(seterror("Unable to find order_id in booking response"));
          return { ok: false, error: "Unable to find order_id in booking response" };
        }
      } else {
        dispatch(setloading(false));
        dispatch(seterror(response.data?.message ?? "Failed to create meeting booking"));
        return { ok: false, error: response.data?.message ?? "Failed to create meeting booking" };
      }
    } catch (error: any) {
      dispatch(setloading(false));
      console.error("Booking API error response:", error?.response?.data);
      console.error("Booking API error status:", error?.response?.status);
      const message = error?.response?.data?.message || error?.response?.data?.detail || error?.message || "Failed to create meeting booking";
      dispatch(seterror(message));
      console.error("Error creating meeting booking:", error);
      return { ok: false, error: message };
    }
  }

  // For course purchases, use create-order endpoint
  let payload: any = {
    purchase_type: purchaseType,
  };

  const config = {
    method: 'post',
    maxBodyLength: Infinity,
    url: `${liveBaseURL}/orders/create-order/`,
    headers: {
      Authorization: `Token ${token}`,
      Cookie: 'Cookie_5=value',
    },
    data: payload,
  };

    // let payload = {};

  if (isAssignment) {
    payload = {
      purchase_type: "practice_assignment",
      assignment_id: assignment?.assignment_id,
      price: price,
    };
  }


    // let payload = {};

  if (isAssignment) {
    payload = {
      purchase_type: "practice_assignment",
      assignment_id: assignment?.assignment_id,
      price: price,
    };
  }


  try {
    const response = await axios.request({
      ...config,
  ...(isAssignment && { data: payload }),
    });
    // console.log(JSON.stringify(response.data));

    dispatch(setloading(false));
    if (response.data?.status === 200) {
      dispatch(setProceedToPay(response.data));
    } else {
      dispatch(seterror(response.data?.message ?? "Something Went Wrong!"));
    }
  } catch (error) {
    if (axios.isAxiosError(error) && error.response) {
      dispatch(seterror(error.response.data.message ?? "An error occurred"));
    } else {
      dispatch(seterror("An unexpected error occurred"));
    }
    dispatch(setloading(false));
  }
};

// Exports
export { proceedToPayData, resetProceedToPay };